import { render, staticRenderFns } from "./ClientElement.vue?vue&type=template&id=c89f1c70&scoped=true"
import script from "./ClientElement.vue?vue&type=script&lang=js"
export * from "./ClientElement.vue?vue&type=script&lang=js"
import style0 from "./ClientElement.vue?vue&type=style&index=0&id=c89f1c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f1c70",
  null
  
)

export default component.exports